module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAe0lEQVR4AWNwL/ChKR7mFqwO5Vy1KoTj1ZoQTmOaWAAyfFUoxz+YJbSwwAtkASWWgAiaWgIiSLZkdQiHCtVTEdDwCHIsARHkWnKPGEtABImWsKeQYgmIoNgSOlpA/yCiPJLpm0zpn9HoX1QQNnyIFdehHKthho/WyTTDACBZgJjeHPW6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/fission-activity-arrow.png
// module id = emK7
// module chunks = 216